<template>
    <div>
        <button
            class="btn btn-md is-ghost ml-sm"
            @click="$modal.show(modalName)"
        >
            Hantera manuellt
        </button>
        <adaptive-form-modal
            :name="modalName"
            primary-button-text="Hantera manuellt"
            title="Hantera manuellt"
            :callback="reloadPage"
            :action="route('admin.invoices.store')"
        >
            <input
                type="hidden"
                name="action"
                value="manually"
            >
            <input
                type="hidden"
                name="address_id"
                :value="addressId"
            >
            <input
                type="hidden"
                name="invoice_trigger_id"
                :value="invoiceTriggerId"
            >
            <p>
                Är du säker på att fakturan ska hanteras manuellt?
            </p>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            addressId: {
                type: Number,
                required: true,
            },
            invoiceTriggerId: {
                type: Number,
                required: true,
            },
        },
        computed: {
            modalName() {
                return `confirm-manually-${this.invoiceTriggerId}`;
            },
        },
        methods: {
            reloadPage() {
                window.location = window.location.href;
            },
        },
    };
</script>
